import { useState } from "react";
import { toDatetimeLocal } from "../../utils/dateUtils";

export default function MedicationForm({ onAdd }) {
  const [date, setDate] = useState(() => toDatetimeLocal());
  const [medication, setMedication] = useState("");
  const [dosage, setDosage] = useState("");
  const [reason, setReason] = useState("");
  const [notes, setNotes] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!medication || !dosage) return;

    onAdd({
      date: new Date(date).toISOString(),
      medication: medication,
      dosage: dosage,
      reason: reason || "",
      type: "medication",
      notes: notes || "",
    });

    setDate(toDatetimeLocal());
    setMedication("");
    setDosage("");
    setReason("");
    setNotes("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-3">
      <div className="row g-2 mb-2">
        <div className="col-md-4">
          <label className="form-label">Date & Time</label>
          <input
            type="datetime-local"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
      </div>
      <div className="row g-2">
        <div className="col-md-3">
          <label className="form-label">Medication</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. Tylenol"
            value={medication}
            onChange={(e) => setMedication(e.target.value)}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Dosage</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. 2.5ml"
            value={dosage}
            onChange={(e) => setDosage(e.target.value)}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Reason</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. Fever"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button type="submit" className="btn btn-info w-100">
            Log Medication
          </button>
        </div>
      </div>
      <div className="row g-2 mt-1">
        <div className="col-12">
          <textarea
            className="form-control form-control-sm"
            placeholder="Add a note..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={2}
            style={{ resize: "none" }}
          />
        </div>
      </div>
    </form>
  );
}
